var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlashOffGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1949_47911",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1949_47911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.486 22.5146L24.4999 20.5284L26.3888 17.7784H22.1388L21.486 17.1257L24.6666 6.11174H14.4443V10.4729L11.6666 7.69511V6.11174C11.6666 5.34785 11.9386 4.69392 12.4825 4.14994C13.0265 3.60597 13.6804 3.33398 14.4443 3.33398H25.4166C26.1388 3.33398 26.7291 3.62103 27.1874 4.19511C27.6458 4.76916 27.7731 5.40804 27.5694 6.11174L24.9999 15.0007H27.6805C28.5115 15.0007 29.1289 15.371 29.5329 16.1118C29.9369 16.8525 29.8935 17.5747 29.4027 18.2784L26.486 22.5146ZM33.5694 37.5423L23.2222 27.1951L18.5693 33.9312C18.4212 34.1442 18.243 34.2784 18.0346 34.334C17.8263 34.3895 17.6166 34.3835 17.4055 34.3158C17.1943 34.2481 17.0184 34.1296 16.8777 33.9603C16.737 33.791 16.6666 33.5823 16.6666 33.334V23.334H14.4443C13.6804 23.334 13.0265 23.062 12.4825 22.518C11.9386 21.9741 11.6666 21.3201 11.6666 20.5562V15.6395L2.45825 6.43119L4.44438 4.44511L35.5555 35.5562L33.5694 37.5423Z",
    fill: "#009B77"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashOffGreen);
export default __webpack_public_path__ + "static/media/flash_off_green.564588cac1e41fed00104251eed05537.svg";
export { ForwardRef as ReactComponent };